import useSWR from "swr";

const DEFAULT_INTERVAL = 20000;

const usePolling = (key, fetcher, options = {}) => {
  return useSWR(key, fetcher, {
    refreshInterval: DEFAULT_INTERVAL,
    ...options,
  });
};

export default usePolling;
